import { SvgLogo } from '@obvio/svg'
import { UserPanelSettings } from '@obvio/template'

import type { ReactElement } from 'react'

function Orders(): ReactElement {
  return <UserPanelSettings logo={SvgLogo} />
}

export default Orders
